<template>
  <div no-body class="lku-charges">
    <!-- <b-row v-if="lkuLoading" class="justify-content-center mb-2">
      <span style="color:blue;">Loading data ...</span>
    </b-row> -->
    <b-row>
      <b-col cols="12">
        <b-form-group label-cols="1" label="Filter">
          <b-form-row>
            <b-col cols="4">
              <b-form-input
                v-model="tblData.CustCode"
                placeholder="Debitur Code  (% for wildcard)"
                @keyup.13.native="refresh()"
              ></b-form-input>
            </b-col>
            <b-col cols="4">
              <b-form-input
                v-model="tblData.CustName"
                placeholder="Debitur Name  (% for wildcard)"
                @keyup.13.native="refresh()"
              ></b-form-input>
            </b-col>
            <b-col cols="4">
              <b-form-input
                v-model="tblData.alamtktp"
                placeholder="Alamat  (% for wildcard)"
                @keyup.13.native="refresh()"
              ></b-form-input>
            </b-col>
          </b-form-row>
        </b-form-group>
      </b-col>
    </b-row>
    <b-card no-body>
      <b-table
        class="mb-0"
        ref="tblCust"
        style="font-size: smaller"
        responsive
        small
        striped
        hover
        :items="data"
        :fields="fields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="selectItem"
        show-empty
        :busy="lkuLoading"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(alamat)="data">
          {{ data.item.alamat }}
          {{ data.item.kelurahan }} {{ data.item.kecamatan }}
        </template>
        <template v-slot:cell(kota)="data">
          {{ data.item.kota }}
          {{ data.item.provinsi }}
        </template>
        <template v-slot:empty="scope">
          <h6 class="text-center mt-2 mb-2">{{ scope.emptyText }}</h6>
        </template>
        <template v-slot:emptyfiltered="scope">
          <h6 class="text-center mt-2 mb-2">{{ scope.emptyFilteredText }}</h6>
        </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="3">
          <b-row class="ml-2 mt-2">
            <span class="pt-1 pr-2">Limit per page</span>
            <b-form-select
              :options="[10, 15, 20, 25]"
              :plain="true"
              v-model="tblData.limit"
              size="sm"
              style="width: 80px !important"
            />
          </b-row>
        </b-col>
        <b-col cols="5">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<style lang="scss">
.lku-charges {
  td {
    padding: 0;

    a {
      //   border: 1px solid;
      text-decoration: none;
      display: block;
      padding: 0.5rem 0.75rem;
    }
  }
}
</style>

<script>
import debitur from "../../apis/debitur";
import toastr from "mini-toastr";

export default {
  data() {
    return {
      fields: [
        { key: "CustCode", label: "Customer Code", sortable: true },
        { key: "nomoridentitas", label: "No Indentitas", sortable: true },
        { key: "CustName", label: "Customer Name", sortable: true },
        {
          key: "alamatktp",
          label: "Address",
          sortable: true,
        },
        {
          key: "kotaktp",
          label: "City",
          sortable: true,
        },
      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: "CustName",
        sortDesc: false,
        CustCode:'',
        CustName:'',
        alamtktp:'',
      },
      lkuLoading: false,
    };
  },
  methods: {
    data: async function (ctx) {
      try {
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        this.lkuLoading = true;
        const list = await debitur.list(this.tblData);
        this.lkuLoading = false;
        return list;
      } catch (error) {
        this.lkuLoading = false;
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
        this.saveEnabled = true;
      }
    },
    selectItem(item, index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
      this.tblData = { name: "", contact: "" };
      this.refresh();
    },
    keymonitor: function (event) {
      console.log(event.key);
      if (event.key == "Enter") {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblCust.refresh();
      }
    },
    refresh() {
      this.$refs.tblCust.refresh();
    },
  },
};
</script>
